import * as React from 'react';

import {SearchTag} from 'components/atoms/Tags/SearchTag';
import {SITE_URLS} from 'features/search/constants';
import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';
import {getSiteSpecificConfig} from 'features/services/utils/env-helper';
import {getFormattedMessage} from 'features/services/utils/language-helper';

import './style.scss';
import {ButtonLink} from '@atoms/LinksAndButtons/ButtonLink';
import {useNavigate} from 'react-router';
import {Tag} from "features/search/types";
import {EpiLink} from "features/template/types";

import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';

interface Props {
    featuredTags: Tag[];
    pageSuggestionTags?: EpiLink[];
    hideShowMore?: boolean;
}

export const SuggestedTags: React.FunctionComponent<Props> = ({pageSuggestionTags, featuredTags, hideShowMore}) => {

    const navigate = useNavigate();
    const isMobile = useDeviceStore(selectIsMobile);

    const onClick = (tag: Tag) => () => {
        if(tag.url) {
            navigate(`${getSiteSpecificConfig().searchUrl.slice(0, -1)}` + tag.url);
        }
    };

    if(pageSuggestionTags && pageSuggestionTags.length === 0 && featuredTags && featuredTags.length === 0) return null;

    return (
        <div className="suggested-tags">
            {featuredTags && featuredTags.map(tag => {
                return <SearchTag
                    tag={tag}
                    light
                    key={`tag-${tag.name}`}
                    onClick={onClick(tag)}
                    hideType
                    useName
                />
            })}

            {pageSuggestionTags && pageSuggestionTags.map(pageTag => {
                return(
                    <ButtonLink
                        href={pageTag.url}
                        key={`tag-${pageTag.name}`}
                        className="search-tag search-tag--clickable button--ghost--no-remove notranslate"
                        buttonColor={ButtonColor.LIGHT} 
                        buttonSize={ButtonSize.SMALL} 
                        buttonType={ButtonType.DEFAULT} 
                    >
                        {pageTag.name}
                    </ButtonLink>
                )
            })}

            {!hideShowMore && (featuredTags && featuredTags.length >= 1 || pageSuggestionTags && pageSuggestionTags.length >= 1) &&
                <div className="suggested-tags__show-all">
                    <ButtonLink 
                        href={SITE_URLS.searchUrl} 
                        className='search-tag' 
                        buttonColor={ButtonColor.LIGHT} 
                        buttonSize={ButtonSize.SMALL} 
                        buttonType={ButtonType.GHOST} 
                    >
                        {isMobile
                            ? getFormattedMessage('jm.components.StartPage.seeAll')
                            : getFormattedMessage('jm.components.StartPage.seeAllDesktop')
                        }
                    </ButtonLink>
                </div>
            }
        </div>
    );
};
